export const shortcutsOverlayContainerStyles = {
  position: 'fixed',
  left: '50%',
  bottom: '24px',
  transform: 'translateX(-50%)',
  zIndex: 10,
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  padding: '10px 14px',
  borderRadius: '12px',
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
  pointerEvents: 'none',
};

export const shortcutsOverlayItemStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const shortcutsOverlayKeycapStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '24px',
  padding: '0 8px',
  borderRadius: '6px',
  backgroundColor: ({ palette }) => palette.background.hoverDefault,
  color: ({ palette }) => palette.text.primary,
  lineHeight: 1,
  whiteSpace: 'nowrap',
};

export const shortcutsOverlayLabelStyles = {
  color: ({ palette }) => palette.text.secondary,
  whiteSpace: 'nowrap',
};
